import { Helmet } from 'react-helmet'
import Header from '../../../../Components/Header'
import MainContent from './Maincontent'
const QualityGoalList = () => {
  return (
     <div className='d-flex flex-column' style={{minHeight:'99.7vh'}}>

      <Helmet>
				<title>Quality Goal List</title>
			</Helmet>
    <Header />
    <MainContent />
    </div>
  )
}
export default QualityGoalList